import { render, staticRenderFns } from "./Snack.vue?vue&type=template&id=314b06c2&scoped=true&lang=html"
import script from "./Snack.vue?vue&type=script&lang=js"
export * from "./Snack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314b06c2",
  null
  
)

export default component.exports